"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomSections = exports.getSpecialNotes = exports.getTreatmentPlan = exports.getHistory = exports.getGeneralExaminations = exports.getChiefComplaintsorDiagnosis = exports.getMedicineSchedule = exports.getMedicineName = exports.getFollowup = exports.getInvestigations = exports.getAdvices = exports.getPrescriptionAsList = exports.InsulinMedicinesId = void 0;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
exports.InsulinMedicinesId = require('../src/MedicineInsulinIDs.json');
var getPrescriptionAsList = function (prescription) {
    var prescriptionList = [];
    var patient = [], doctorName = [], medicineList = [], adviceList = [], investigationList = [], followupList = [];
    if (prescription.patient)
        patient.push(getPatientNameAgeAndPhone(prescription.patient));
    if (prescription.doctorName)
        doctorName.push(getDoctorName(prescription.doctorName));
    if (prescription.prescriptionData.advices)
        adviceList = (0, exports.getAdvices)(prescription.prescriptionData.advices);
    if (adviceList.length)
        adviceList.unshift("\nAdvices: ");
    if (prescription.prescriptionData.investigations)
        investigationList = (0, exports.getInvestigations)(prescription.prescriptionData.investigations);
    if (investigationList.length)
        investigationList.unshift("\nInvestigations: ");
    if (prescription.prescriptionData.followupEntry)
        followupList = (0, exports.getFollowup)(prescription.prescriptionData.followupEntry);
    if (followupList.length)
        followupList.unshift("\nFollow-up: ");
    if ((0, lodash_1.isEmpty)(prescription.prescriptionData.medicineEntries) === false) {
        prescription.prescriptionData.medicineEntries.forEach(function (medicine) {
            var currentMedicineNameAndSchedule = "";
            currentMedicineNameAndSchedule +=
                (0, exports.getMedicineName)(medicine.medicine) + "\n";
            currentMedicineNameAndSchedule +=
                (0, exports.getMedicineSchedule)(medicine.template, medicine) + "\n";
            if ((0, lodash_1.isEmpty)(medicine.multiplePlans) === false) {
                medicine.multiplePlans.forEach(function (multiplePlan) {
                    currentMedicineNameAndSchedule +=
                        (0, exports.getMedicineSchedule)(medicine.template, multiplePlan) + "\n";
                });
            }
            medicineList.push(currentMedicineNameAndSchedule);
        });
    }
    prescriptionList = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], patient, true), doctorName, true), medicineList, true), adviceList, true), investigationList, true), followupList, true);
    return prescriptionList;
};
exports.getPrescriptionAsList = getPrescriptionAsList;
var getPatientNameAgeAndPhone = function (patient) {
    if ((0, lodash_1.isEmpty)(patient) === false) {
        var name_1 = patient.name ? "Name: ".concat(patient.name, "\n") : "";
        var years = patient.age
            ? patient.age.years
                ? "".concat(patient.age.years, " years ")
                : ""
            : "";
        var months = patient.age
            ? patient.age.months
                ? "".concat(patient.age.months, " months ")
                : ""
            : "";
        var days = patient.age
            ? patient.age.days
                ? "".concat(patient.age.days, " days")
                : ""
            : "";
        var age = years || months || days ? "Age: ".concat(years, " ").concat(months, " ").concat(days, "\n") : "";
        var phone = patient.phone ? "Phone: ".concat(patient.phone, "\n") : "";
        return "".concat(name_1).concat(age).concat(phone);
    }
    return "";
};
var getDoctorName = function (doctorName) {
    if ((0, lodash_1.isEmpty)(doctorName) === false) {
        var name_2 = doctorName;
        return "Doctor Name: ".concat(name_2) + "\n\n";
    }
    return "";
};
var getAdvices = function (advices) {
    var adviceList = [];
    if (advices) {
        advices.forEach(function (advice, idx) {
            try {
                var entry = advice.entity.name;
                advice.notes
                    ? (entry = "".concat(entry, "(").concat(advice.notes, ")"))
                    : (entry = "".concat(entry));
                idx === advices.length - 1
                    ? adviceList.push("".concat(entry))
                    : adviceList.push("".concat(entry, ", "));
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return adviceList;
};
exports.getAdvices = getAdvices;
var getInvestigations = function (investigations) {
    var investigationList = [];
    if (investigations) {
        investigations.forEach(function (investigation, idx) {
            try {
                var entry = investigation.entity.name;
                investigation.result && investigation.instruction
                    ? (entry = "".concat(entry, "(Result: ").concat(investigation.result, " Instruction: ").concat(investigation.instruction, ")"))
                    : investigation.result
                        ? (entry = "".concat(entry, "(Result: ").concat(investigation.result, ")"))
                        : investigation.instruction
                            ? (entry = "".concat(entry, "(Instruction: ").concat(investigation.instruction, ")"))
                            : (entry = investigation.entity.name);
                idx === investigations.length - 1
                    ? investigationList.push("".concat(entry))
                    : investigationList.push("".concat(entry, ", "));
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return investigationList;
};
exports.getInvestigations = getInvestigations;
var getFollowup = function (followup) {
    var followups = [];
    if ((0, lodash_1.isEqual)(followup.duration, "0") === false &&
        (0, lodash_1.isEmpty)(followup.duration) === false) {
        followups.push("".concat(followup.duration, " ").concat(followup.durationInterval, " \u09AA\u09B0"));
    }
    if ((0, lodash_1.isEmpty)(followup.date) === false) {
        followups.push((0, moment_1.default)(followup.date).format("Do MMM YYYY"));
    }
    var remarks = "";
    followup.remark
        ? followup.remark.forEach(function (remark, idx) {
            idx === followup.remark.length - 1
                ? (remarks += "".concat(remark.name))
                : (remarks += "".concat(remark.name, ", "));
        })
        : (remarks = "");
    if (remarks)
        followups.push("\n".concat(remarks));
    return followups;
};
exports.getFollowup = getFollowup;
var getMedicineNameWithStrength = function (name, strengths) {
    var val = "";
    var strength = strengths
        ? strengths.length === 1
            ? strengths[0] === null
                ? ""
                : strengths[0]
            : ""
        : "";
    var medicineName = name.split(" ");
    var strengthInMedicineName = medicineName[medicineName.length - 1];
    var numberAndStrengthInMedicineName = medicineName.slice(-2);
    var medicineStrength = strength.split(" ");
    var strengthNumber = medicineStrength[0];
    if (strengthInMedicineName === strengthNumber) {
        medicineName.pop();
    }
    else if ((0, lodash_1.isEqual)(numberAndStrengthInMedicineName, medicineStrength)) {
        medicineName = medicineName.slice(0, medicineName.length - 2);
    }
    else if (parseFloat(strengthInMedicineName) && parseFloat(strengthNumber)) {
        if ((0, lodash_1.isEqual)(parseFloat(strengthInMedicineName), parseFloat(strengthNumber))) {
            medicineName.pop();
        }
    }
    else if (parseFloat(numberAndStrengthInMedicineName[0]) &&
        parseFloat(strengthNumber)) {
        if ((0, lodash_1.isEqual)(parseFloat(numberAndStrengthInMedicineName[0]), parseFloat(strengthNumber))) {
            medicineName = medicineName.slice(0, medicineName.length - 2);
        }
    }
    if ((0, lodash_1.isEqual)(strength.trim(), "")) {
        val = "".concat(medicineName.join(" "));
    }
    else {
        val = "".concat(medicineName.join(" "), " (").concat(strength, ")");
    }
    return val.trim();
};
var getMedicineName = function (medicine) {
    var val = "";
    var medicineNameWithStrength = getMedicineNameWithStrength(medicine.name, medicine.strengths);
    if ((0, lodash_1.isEmpty)(medicine.type) === false) {
        var sanitizedType_1 = medicine.type.trim().toLowerCase();
        if ((0, lodash_1.isEqual)(sanitizedType_1, "capsule")) {
            val = "Cap. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "tablet")) {
            val = "Tab. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "syrup")) {
            val = "Syrp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "suppository")) {
            val = "Supp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "suspension")) {
            val = "Susp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "powder for suspension")) {
            val = "Susp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "injection")) {
            val = "Inj. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "aerosol inhalation")) {
            val = "".concat(medicineNameWithStrength, " Inhaler");
        }
        else if ((0, lodash_1.some)(["IV/IM Injection", "IM Injection", "IV Injection"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "Inj. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)(["Count Cr Capsule", "Er Capsule", "M R Capsule", "Sr Capsule"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "Cap. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)([
            "Count Cr Tablet",
            "Dr. Tablet",
            "Er Tablet",
            "Md Tablet",
            "Sr Tablet",
            "Xr Tablet",
            "Tablet (Controlled Release)",
            "Tablet (Delayed Release)",
            "Tablet (Enteric Coated)",
            "Tablet (Extended Release)",
            "Tablet (Modified Release)",
            "Tablet (Sustained Release)",
            "Tablet (Timed Release)",
            "Chewable Tablet",
            "Mouth Dissolving Tablet",
            "Dispersible Tablets",
            "Effervescent Tablet",
            "Orodispersible Tablet",
            "Vaginal Tablet"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "Tab. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)([
            "Capsule (Extended Release)",
            "Capsule (Delayed Release)",
            "Capsule (Controlled Release)",
            "Capsule (Sustained Release)",
            "Capsule (Modified Release)",
            "Capsule (Timed Release)",
            "Capsule (Acucap)",
            "Capsule (Easycap)",
            "Capsule (Liquid Filled)",
            "Capsule (Micronized)",
            "Capsule (Pellet)",
            "Soft Capsule",
            "Soft Gelatin Capsule",
            "Sprinkle Capsule",
            "Bexicap",
            "Convicap Capsule",
            "Inhalation Capsule",
            "Rotacap",
            "Cozycap"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "Cap. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)([
            "Drop",
            "Ear Drop",
            "Eye Drop",
            "Eye/Ear Drop",
            "Eye/Ear Drops",
            "Eye/Ear/Nasal Drops",
            "Eye/Nasal Drop",
            "Nasal Drop",
            "Pediatric Drops",
            "Pediatric Nasal Drop"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Drop");
        }
        else if ((0, lodash_1.some)([
            "IM Injection",
            "IM/Deep SC Injection",
            "IM/IA Injection",
            "IM/IV Injection",
            "IM/SC Injection",
            "Injection",
            "Intra-Articular Injection",
            "Intraspinal Injection",
            "IV Injection",
            "IV Injection or Infusion",
            "IV/SC Injection",
            "SC Injection"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "Inj. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)(["Cream", "Vaginal Cream"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "".concat(medicineNameWithStrength, " Cream");
        }
        else if ((0, lodash_1.some)(["Eye Ointment", "Eye/Ear Ointment", "Ointment", "Rectal Ointment"].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Ointment");
        }
        else if ((0, lodash_1.some)([
            "Dental Gel",
            "Eye Gel",
            "Gel",
            "Oral Gel",
            "Topical Gel",
            "Vaginal Gel"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Gel");
        }
        else if ((0, lodash_1.some)([
            "Concentrated Oral Solution",
            "Dialysis Solution",
            "Irrigation Solution",
            "Nebuliser Solution",
            "Ophthalmic Solution",
            "Oral Solution",
            "Powder for Solution",
            "Respirator Solution",
            "Solution",
            "Solution for Inhalation",
            "Topical Solution"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Solution");
        }
        else if ((0, lodash_1.some)(["Suppository", "Vaginal Suppository"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "Supp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)([
            "Oral Powder",
            "Powder",
            "Powder for Inhalation",
            "Powder for Injection"
        ].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Powder");
        }
        else if ((0, lodash_1.some)(["Spray", "Nasal Spray"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "".concat(medicineNameWithStrength, " Spray");
        }
        else if ((0, lodash_1.some)(["Oral Suspension", "Powder for Suspension"].map(function (t) {
            return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase());
        }))) {
            val = "Susp. ".concat(medicineNameWithStrength);
        }
        else if ((0, lodash_1.some)(["Inhaler"].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " Inhaler");
        }
        else if ((0, lodash_1.some)(["IV Infusion"].map(function (t) { return (0, lodash_1.isEqual)(sanitizedType_1, t.trim().toLowerCase()); }))) {
            val = "".concat(medicineNameWithStrength, " IV Infusion");
        }
        else if ((0, lodash_1.isEqual)(sanitizedType_1, "null")) {
            val = medicineNameWithStrength;
        }
        else {
            val = "".concat(medicineNameWithStrength, " ").concat(medicine.type);
        }
    }
    return val ? val : medicineNameWithStrength;
};
exports.getMedicineName = getMedicineName;
var getMedicineSchedule = function (template, medicine) {
    var completeSchedule = "";
    var scheduleEntry = "";
    var duration = "";
    var remarks = "";
    if ((0, lodash_1.isEmpty)(medicine.scheduleEntry) === false) {
        if ((0, lodash_1.findIndex)(exports.InsulinMedicinesId, function (m) { var _a; return (0, lodash_1.isEqual)(m, (_a = medicine.medicine) === null || _a === void 0 ? void 0 : _a.id); }) !== -1) {
            medicine.scheduleEntry.entries.forEach(function (entry, idx) {
                idx === medicine.scheduleEntry.entries.length - 1
                    ? (scheduleEntry += entry)
                    : (scheduleEntry += "".concat(entry, " + "));
            });
            if ((0, lodash_1.isEqual)(scheduleEntry, "0 + 0 + 0")) {
                scheduleEntry = "";
            }
            else {
                scheduleEntry += " ".concat(medicine.scheduleEntry.unit);
            }
            if ((0, lodash_1.isEmpty)(medicine.medicineRoute) === false) {
                if ((0, lodash_1.isEmpty)(scheduleEntry) === false) {
                    scheduleEntry += " (Route: ".concat(medicine.medicineRoute, ")");
                }
            }
        }
        else {
            if ((0, lodash_1.isEqual)(template, "Tablet/Capsule")) {
                medicine.scheduleEntry.entries.forEach(function (entry, idx) {
                    idx === medicine.scheduleEntry.entries.length - 1
                        ? (scheduleEntry += entry)
                        : (scheduleEntry += "".concat(entry, " + "));
                });
                if ((0, lodash_1.isEqual)(scheduleEntry, "0 + 0 + 0")) {
                    scheduleEntry = "";
                }
                else {
                    scheduleEntry += " ".concat(medicine.scheduleEntry.unit);
                }
            }
            else if ((0, lodash_1.isEqual)(template, "Syrup/Suppository/Ointment")) {
                if ((0, lodash_1.isEqual)(medicine.scheduleEntry.entries[0], "0") === false) {
                    scheduleEntry = "".concat(medicine.scheduleEntry.entries[0], " ").concat(medicine.scheduleEntry.unit);
                }
                if ((0, lodash_1.isEmpty)(medicine.times) === false) {
                    if ((0, lodash_1.isEqual)(medicine.times[0], "0") === false) {
                        if ((0, lodash_1.isEmpty)(scheduleEntry) === false) {
                            scheduleEntry += " x ".concat(medicine.times, " ").concat(medicine.timesUnit);
                        }
                        else {
                            scheduleEntry += "".concat(medicine.times, " ").concat(medicine.timesUnit);
                        }
                    }
                }
            }
            else if ((0, lodash_1.isEqual)(template, "Injection")) {
                if ((0, lodash_1.isEqual)(medicine.scheduleEntry.entries[0], "0") === false) {
                    scheduleEntry = "".concat(medicine.scheduleEntry.entries[0], " ").concat(medicine.scheduleEntry.unit);
                }
                else {
                    medicine.scheduleEntry.entries.forEach(function (entry, idx) {
                        idx === medicine.scheduleEntry.entries.length - 1
                            ? (scheduleEntry += entry)
                            : (scheduleEntry += "".concat(entry, " + "));
                    });
                    if ((0, lodash_1.isEqual)(scheduleEntry, "0 + 0 + 0")) {
                        scheduleEntry = "";
                    }
                    else {
                        scheduleEntry += " ".concat(medicine.scheduleEntry.unit);
                    }
                }
                if ((0, lodash_1.isEmpty)(medicine.times) === false) {
                    if ((0, lodash_1.isEqual)(medicine.times[0], "0") === false) {
                        if ((0, lodash_1.isEmpty)(scheduleEntry) === false) {
                            scheduleEntry += " x ".concat(medicine.times, " ").concat(medicine.timesUnit);
                        }
                        else {
                            scheduleEntry += "".concat(medicine.times, " ").concat(medicine.timesUnit);
                        }
                    }
                }
                if ((0, lodash_1.isEmpty)(medicine.medicineRoute) === false) {
                    if ((0, lodash_1.isEmpty)(scheduleEntry) === false) {
                        scheduleEntry += " (Route: ".concat(medicine.medicineRoute, ")");
                    }
                }
            }
        }
    }
    completeSchedule += scheduleEntry;
    if ((0, lodash_1.isEmpty)(medicine.durationInterval) === false &&
        (0, lodash_1.isEmpty)(medicine.durationUnit) === false) {
        if ((0, lodash_1.isEqual)(medicine.durationUnit, "continue") ||
            (0, lodash_1.isEqual)(medicine.durationUnit, "চলবে")) {
            duration += medicine.durationUnit;
        }
        else if ((0, lodash_1.isEqual)(medicine.durationUnit, "continue") === false &&
            (0, lodash_1.isEqual)(medicine.durationUnit, "চলবে") === false &&
            (0, lodash_1.isEqual)(medicine.durationInterval, "0")) {
            duration = "";
        }
        else {
            duration += "".concat(medicine.durationInterval, " ").concat(medicine.durationUnit);
        }
    }
    if ((0, lodash_1.isEmpty)(duration) === false) {
        if ((0, lodash_1.isEmpty)(completeSchedule) === false) {
            completeSchedule += " -- ".concat(duration);
        }
        else {
            completeSchedule += duration;
        }
    }
    else {
        completeSchedule += "";
    }
    if ((0, lodash_1.isEmpty)(medicine.remarks) === false) {
        medicine.remarks.forEach(function (rem, idx) {
            idx === medicine.remarks.length - 1
                ? (remarks += rem.name)
                : (remarks += "".concat(rem.name, ", "));
        });
    }
    if ((0, lodash_1.isEmpty)(remarks) === false) {
        if ((0, lodash_1.isEmpty)(completeSchedule) === false) {
            completeSchedule += " -- ".concat(remarks);
        }
        else {
            completeSchedule += remarks;
        }
    }
    else {
        completeSchedule += "";
    }
    return "".concat(completeSchedule);
};
exports.getMedicineSchedule = getMedicineSchedule;
var getChiefComplaintsorDiagnosis = function (elements, type) {
    var items = [];
    if (elements) {
        elements.forEach(function (e, idx) {
            try {
                var entry = e.entity.name;
                if ((0, lodash_1.isEqual)(e.duration, "0") === false &&
                    (0, lodash_1.isEmpty)(e.duration) === false) {
                    if ((0, lodash_1.isEqual)(type, 'complaints')) {
                        entry = "".concat(entry, " (for ").concat(e.duration, " ").concat(e.durationInterval, ")");
                    }
                    else if ((0, lodash_1.isEqual)(type, 'diagnosis')) {
                        entry = "".concat(entry, " (").concat(e.duration, " ").concat(e.durationInterval, " old)");
                    }
                }
                if ((0, lodash_1.isEqual)(e.durationInterval, 'long time') &&
                    ((0, lodash_1.isEqual)(e.duration, "0") ||
                        (0, lodash_1.isEmpty)(e.duration))) {
                    if ((0, lodash_1.isEqual)(type, 'complaints')) {
                        entry = "".concat(entry, " (for ").concat(e.durationInterval, ")");
                    }
                    else if ((0, lodash_1.isEqual)(type, 'diagnosis')) {
                        entry = "".concat(entry, " (").concat(e.durationInterval, " old)");
                    }
                }
                if (e.notes) {
                    entry = "".concat(entry, " -- ").concat(e.notes);
                }
                idx === elements.length - 1
                    ? items.push(entry)
                    : items.push("".concat(entry, ",\n"));
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return items;
};
exports.getChiefComplaintsorDiagnosis = getChiefComplaintsorDiagnosis;
var getGeneralExaminations = function (element) {
    var items = [];
    if ((0, lodash_1.isEmpty)(element) === false) {
        if (element.height.number === 0 && element.heightNew.feet !== 0) {
            items.push("Height: ".concat(element.heightNew.feet, " ft ").concat(element.heightNew.inch && element.heightNew.inch + ' in', "\n"));
        }
        if (element.weight.number) {
            items.push("Weight: ".concat(element.weight.number + ' ' + element.weight.unit));
        }
    }
    return items;
};
exports.getGeneralExaminations = getGeneralExaminations;
var getHistory = function (history) {
    var historyList = [];
    if ((0, lodash_1.isEmpty)(history) === false) {
        history.forEach(function (hist, idx) {
            try {
                var items = "".concat(hist.entity.name, " ").concat(hist.duration ? " duration: (for ".concat(hist.duration, " days)") : '', " ").concat(hist.notes ? " notes: ".concat(hist.notes) : '', "\n");
                historyList.push(items);
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return historyList;
};
exports.getHistory = getHistory;
var getTreatmentPlan = function (treatmentEntry) {
    var treatmentPlanList = [];
    if ((0, lodash_1.isEmpty)(treatmentEntry) === false) {
        treatmentEntry.forEach(function (treatment, idx) {
            try {
                var items = "".concat(treatment.entity.name, " ").concat(treatment.date ? " - date: ".concat((0, moment_1.default)(treatment.date).format('DD/MM/YYYY')) : '', " ").concat(treatment.notes ? " notes: ".concat(treatment.notes) : '', "\n");
                treatmentPlanList.push(items);
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return treatmentPlanList;
};
exports.getTreatmentPlan = getTreatmentPlan;
var getSpecialNotes = function (spnotes) {
    var spNoteList = [];
    if ((0, lodash_1.isEmpty)(spnotes) === false) {
        spnotes.forEach(function (nt) {
            try {
                var items = "".concat(nt.entity.name, " ").concat(nt.notes ? " notes: ".concat(nt.notes) : '', "\n");
                spNoteList.push(items);
            }
            catch (e) {
                if (e instanceof TypeError) {
                    printError(e, true);
                }
                else {
                    printError(e, false);
                }
            }
        });
    }
    return spNoteList;
};
exports.getSpecialNotes = getSpecialNotes;
var getCustomSections = function (cust) {
    var spNoteList = [];
    if (cust) {
        return cust.reduce(function (acc, item) {
            var sectionKey = item.sectionKey.replace('customSection_', '');
            var entityName = "".concat(item.entity.name, " ").concat(item.notes ? ' Notes: ' + item.notes : '');
            if (!acc[sectionKey]) {
                acc[sectionKey] = [];
            }
            acc[sectionKey] = (entityName);
            return acc;
        }, {});
    }
    return spNoteList;
};
exports.getCustomSections = getCustomSections;
var printError = function (error, explicit) {
    console.log("[".concat(explicit ? 'EXPLICIT' : 'INEXPLICIT', "] ").concat(error.name, ": ").concat(error.message));
};
//# sourceMappingURL=Prescription.js.map